import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/config/api';
import AuthLayout, { trackPointer, Field, AlertCircleIcon, CheckCircleIcon, ArrowRightIcon, MailIcon, LockIcon } from '../Auth/AuthLayout';

function InternalAuditForgotPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) { setError('Please enter your work email.'); return; }
        setLoading(true); setError('');
        try {
            const axios = (await import('axios')).default;
            await axios.post(
                API.AUDIT_PORTAL_FORGOT_PASSWORD,
                { email },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Basic YmFzZWFkbWluOmRlZmF1bHRANDU2',
                    },
                }
            );
            setSuccess(true);
        } catch (e) {
            const msg = e?.response?.data?.response_data?.message || e?.response?.data?.error?.message || '';
            setError(msg || 'Something went wrong. Please try again.');
        }
        setLoading(false);
    };

    return (
        <AuthLayout>
            <AuthLayout.Stage/>
            <AuthLayout.Panel>
                <div className="lg-wrap">
                    <header className="lg-form-header">
                        <p className="lg-eyebrow"><LockIcon/> Audit portal</p>
                        <h1 className="lg-title">Forgot password</h1>
                        <p className="lg-lead">Enter your work email and we'll send you a link to reset your password.</p>
                    </header>

                    {success ? (
                        <div className="lg-alert lg-alert--success" role="status">
                            <CheckCircleIcon/>
                            <span>A reset link has been sent to <strong>{email}</strong>. Please check your inbox.</span>
                        </div>
                    ) : (
                        <form className="lg-form" noValidate onSubmit={handleSubmit}>
                            {error && (
                                <div className="lg-alert lg-alert--error" role="alert">
                                    <AlertCircleIcon/> <span>{error}</span>
                                </div>
                            )}

                            <Field
                                name="email"
                                type="email"
                                label="Work email"
                                icon={<MailIcon/>}
                                value={email}
                                onChange={e => { setEmail(e.target.value); setError(''); }}
                                autoComplete="email"
                            />

                            <button type="submit" className="lg-submit lg-spot"
                                disabled={loading} aria-busy={loading} onPointerMove={trackPointer}>
                                {loading ? (
                                    <span className="lg-submit-label"><span className="lg-spin" aria-hidden="true"/> Sending...</span>
                                ) : (
                                    <span className="lg-submit-label">Send reset link <ArrowRightIcon/></span>
                                )}
                                {loading && <i className="lg-scan" aria-hidden="true"/>}
                            </button>
                        </form>
                    )}

                    <p className="lg-signup">
                        <button type="button" className="lg-link" onClick={() => navigate('/audit-portal/login')}>
                            ← Back to login
                        </button>
                    </p>
                </div>

                <p className="lg-trust">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="4.5" y="10.5" width="15" height="10" rx="3"/>
                        <path d="M8 10.5V8a4 4 0 018 0v2.5"/>
                    </svg>
                    Protected by enterprise-grade security. Foresee Security - Internal Audit Portal
                </p>
            </AuthLayout.Panel>
        </AuthLayout>
    );
}

export default InternalAuditForgotPassword;
